import { motion } from "framer-motion";

const GLYPHS = ["☾", "☿", "♀", "⚸", "✷", "☽", "⚹", "✦", "◑", "⟁", "♁", "☉"];

const seeded = GLYPHS.map((g, i) => ({
  g,
  left: (i * 37) % 92,
  top: (i * 53) % 88,
  size: 26 + ((i * 13) % 46),
  dur: 14 + ((i * 7) % 16),
  delay: (i * 1.7) % 8,
}));

export const SigilField = () => (
  <div className="pointer-events-none absolute inset-0 overflow-hidden" aria-hidden="true">
    {seeded.map((s, i) => (
      <motion.span
        key={i}
        className="absolute font-serif text-[#C5A059]"
        style={{ left: `${s.left}%`, top: `${s.top}%`, fontSize: s.size, opacity: 0.06 }}
        animate={{ y: [0, -30, 0], opacity: [0.04, 0.12, 0.04], rotate: [0, 15, 0] }}
        transition={{ duration: s.dur, delay: s.delay, repeat: Infinity, ease: "easeInOut" }}
      >
        {s.g}
      </motion.span>
    ))}
  </div>
);

export default SigilField;
